import { useEffect, useState } from 'react';
import { Card, Col, message, Modal, Popconfirm, Row, Space } from 'antd';
import { WebApiCompanyDtoCompanyDto, WebApiIntegrationsDtoIntegrationDto, } from '../../Repository/eventbookyapi';
import { AuthProvider } from '../../Providers/authProvider';
import { useAuth } from '../../Contexts/AuthContext';
import { TextService } from '../../Services/TextService';
import { CheckCircleOutlined, DeleteOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Paragraph from 'antd/lib/typography/Paragraph';
import LeftMenuSettings from './LeftSettings';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BookyButton } from '../../Components/Buttons/BookyButton';
import { IntegrationService } from '../../Services/IntegrationService';
import { IntegrationType } from '../../Types/IntegrationType';
import { IntegrationState } from '../../Types/IntegrationState';
import { formatDateString } from '../../Helpers/DateHelpers';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { CompanyService } from '../../Services/CompanyService';

const AdminIntegrations = () => {
    const [activeIntegrations, setActiveIntegrations] = useState([] as WebApiIntegrationsDtoIntegrationDto[]);

    const { user } = useAuth();
    const GetText = TextService.GetText;
    const { confirm } = Modal;
    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoadingFortnox, setIsLoadingFortnox] = useState(false as boolean);
    const [isLoadingPingPayments, setIsLoadingPingPayments] = useState(false as boolean);
    const [integrationToDelete, setIntegrationToDelete] = useState(0 as number);
    const [fortNoxIntegration, setFortNoxIntegration] = useState(null as WebApiIntegrationsDtoIntegrationDto | null);
    const [company, setCompany] = useState(null as WebApiCompanyDtoCompanyDto | null);

    const [pingPaymentsIntegration, setPingPaymentsIntegration] = useState(null as WebApiIntegrationsDtoIntegrationDto | null);
    const [showPingPaymentsInfo, setShowPingPaymentsInfo] = useState(false);
    const [showFortnoxInfo, setShowFortnoxInfo] = useState(false);

    const [lastRunCount, setLastCountRun] = useState(null as WebApiIntegrationsDtoIntegrationDto | null);

    var hasInitConnection = false;
    const navigation = useNavigate();

    useEffect(() => {
        CompanyService.GetCompany().then(company => {
            setCompany(company);
        })

        AuthProvider().ValidateUserLogin();

        loadActiveIntegrations();

        if (searchParams.get('state') == "Connect_1" && !hasInitConnection) {
            hasInitConnection = true;
            var activationCode = searchParams.get('code');
            IntegrationService.ConnectIntegration({
                accessCode: activationCode,
                integrationType: IntegrationType.Fortnox
            }).then(loadActiveIntegrations);
        }
    }, []);

    const loadActiveIntegrations = () => {
        IntegrationService.GetActiveIntegrations().then(result => {
            setActiveIntegrations(result);
            var fortNox = result.find(p => p.type == IntegrationType.Fortnox)
            var pingPayments = result.find(p => p.type == IntegrationType.PingPayments)

            fortNox ? setFortNoxIntegration(fortNox) : setFortNoxIntegration(null);
            pingPayments ? setPingPaymentsIntegration(pingPayments) : setPingPaymentsIntegration(null);
        });
    }

    const navigateToFortnox = async () => {
        var response = await IntegrationService.GetIntegration(IntegrationType.Fortnox);
        window.location.href = response.activationUri!;
    }

    const navigateToPingPaymentCreateMerchant = async () => {
        if (!company?.organisationNumber) {
            message.warning("Organisationsnummer behövs för att aktivera integrationen. Fyll i organisationsnummer under Konto och försök igen.")
            return;
        }

        navigation("/" + getCurrentLanguage() + "/pingpayments-integration");
    }

    const GetfortNoxInvoices = async () => {
        setIsLoadingFortnox(true);
        var response = await IntegrationService.GetInvoices(IntegrationType.Fortnox);
        loadActiveIntegrations();
        setIsLoadingFortnox(false);
    }

    const onDeleteClick = (memberId: number) => {
        setIntegrationToDelete(memberId);
    };

    const handleOk = async () => {
        await await IntegrationService.RemoveIntegration(integrationToDelete);
        loadActiveIntegrations();
        setIsLoadingFortnox(false);
        setIsLoadingPingPayments(false);
    };
    return <LayoutLeftMenu title={GetText("Integrations_IntegrationTitle")} menu={<LeftMenuSettings selected={"integrations"} />}>
        <Space>
            <Paragraph>{GetText("Integrations_Description")}</Paragraph>
        </Space>

        <div>
            <Row gutter={24}>
                <Col span={4}>
                    <Card
                        className="integration-card"
                        cover={
                            <img
                                alt="example"
                                src={require('../../Images/fortnox.png')}
                            />
                        }>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <InfoCircleOutlined
                                style={{ fontSize: '20px', color: '#1890ff', cursor: 'pointer' }}
                                onClick={() => setShowFortnoxInfo(true)}
                                title="Visa priser och information"
                            />
                        </div>

                        {fortNoxIntegration ?
                            <>
                                <p style={{ height: "200px" }}>

                                    Med fortnox kan du koppla ihop OneFront 360 och läsa in fakturor och betalningar för avprickning av medlemsavgift.<br /><br />
                                </p>
                                {fortNoxIntegration.state == IntegrationState.Active ? <span><CheckCircleOutlined style={{ color: "green" }} /> Integrationen är aktiv.</span> : ""}

                                {fortNoxIntegration.state == IntegrationState.Error ? <span><ExclamationCircleOutlined style={{ color: "red" }} /> Fel inträffade vid senaste körningen. Tekniskt felmeddelande: <br /><i>{fortNoxIntegration.lastrunResponse}</i></span> : ""}


                                <br /><br />Senast synkroniserat: {formatDateString(fortNoxIntegration?.lastRun)}
                                <BookyButton style={{ marginTop: "10px" }} text={"Synkronisera fakturor och betalningar"} onClick={(e: any) => GetfortNoxInvoices()}></BookyButton>

                                <Popconfirm
                                    title={GetText("Integrations_RemoveIntegrationConfirm")}
                                    key={fortNoxIntegration?.id!}
                                    open={fortNoxIntegration?.id! === integrationToDelete}
                                    placement="topRight"
                                    onConfirm={handleOk}
                                    onCancel={() => setIntegrationToDelete(0)}
                                >
                                </Popconfirm>
                                <br />
                                {fortNoxIntegration.state == IntegrationState.Error ? <><BookyButton loading={isLoadingFortnox} style={{ marginTop: "10px" }} text={GetText("Integrations_Connect")} onClick={navigateToFortnox}></BookyButton><br /> </> : ""}

                                <BookyButton style={{ marginTop: "10px" }} danger text={GetText("Integrations_RemoveIntegrationButton")} onClick={(e: any) => onDeleteClick(fortNoxIntegration?.id!)}></BookyButton>

                            </> : <>
                                <p style={{ height: "200px" }}>

                                    Med fortnox kan du koppla ihop OneFront 360 och läsa in fakturor och betalningar för avprickning av medlemsavgift.<br /><br />
                                </p>                                <br />
                                <BookyButton fullWidth loading={isLoadingFortnox} disabled={fortNoxIntegration} style={{ marginTop: "10px" }} text={GetText("Integrations_Connect")} onClick={navigateToFortnox}></BookyButton>
                            </>
                        }

                    </Card>
                </Col>
                <Col span={4}>

                    <Card
                        className='integration-card'
                        cover={
                            <img
                                alt="example"
                                src={require('../../Images/pingpayments.png')}
                            />
                        }>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <p style={{ height: "200px", flex: 1 }}>
                                Med ping payments kan du koppla ihop OneFront 360 och ta betalt av dina medlemmar/kunder och få automatisk avprickning vem som betalat. Klicka här för att koppla ihop OneFront 360 med Ping Payments.<br /><br />
                            </p>
                            <InfoCircleOutlined
                                style={{ fontSize: '20px', color: '#1890ff', cursor: 'pointer', marginLeft: '10px' }}
                                onClick={() => setShowPingPaymentsInfo(true)}
                                title="Visa priser och information"
                            />
                        </div>
                        <br />
                        {pingPaymentsIntegration ?
                            <>
                                {pingPaymentsIntegration.state == IntegrationState.Active ? <span><CheckCircleOutlined style={{ color: "green" }} /> Integrationen är aktiv.</span> : ""}

                                <Popconfirm
                                    title={GetText("Integrations_RemoveIntegrationConfirm")}
                                    key={pingPaymentsIntegration?.id!}
                                    open={pingPaymentsIntegration?.id! === integrationToDelete}
                                    placement="topRight"
                                    onConfirm={handleOk}
                                    onCancel={() => setIntegrationToDelete(0)}
                                >
                                </Popconfirm>
                                <br />
                                {pingPaymentsIntegration.state == IntegrationState.Error ? <><BookyButton loading={isLoadingPingPayments} style={{ marginTop: "10px" }} text={GetText("Integrations_Connect")} onClick={navigateToFortnox}></BookyButton><br /> </> : ""}
                                <BookyButton style={{ marginTop: "10px" }} danger text={GetText("Integrations_RemoveIntegrationButton")} onClick={(e: any) => onDeleteClick(pingPaymentsIntegration?.id!)}></BookyButton>


                            </> : <BookyButton fullWidth loading={isLoadingPingPayments} disabled={pingPaymentsIntegration} style={{ marginTop: "10px" }} text={GetText("Integrations_Connect")} onClick={navigateToPingPaymentCreateMerchant}></BookyButton>
                        }

                    </Card>
                </Col>
            </Row>
        </div>

        <Modal
            title="Fortnox - Priser och Information"
            open={showFortnoxInfo}
            onCancel={() => setShowFortnoxInfo(false)}
            footer={[
                <BookyButton key="close" onClick={() => setShowFortnoxInfo(false)} text="Stäng" />
            ]}
            width={700}
        >
            <div style={{ lineHeight: '1.8' }}>
                <h3>Priser per nivå</h3>
                <p>Samtliga priser är exklusive moms och debiteras årligen.</p>

                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Nivå</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Pris</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Bas 0-250</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>150 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Bas 250-500</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>300 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Bas 500-1000</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>500 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Premium</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>1 000 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>Enterprise</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>2 500 kr</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Modal>

        <Modal
            title="Ping Payments - Priser och Information"
            open={showPingPaymentsInfo}
            onCancel={() => setShowPingPaymentsInfo(false)}
            footer={[
                <BookyButton key="close" onClick={() => setShowPingPaymentsInfo(false)} text="Stäng" />
            ]}
            width={700}
        >
            <div style={{ lineHeight: '1.8' }}>
                <h3>Automatiskt betalning</h3>
                <p>I denna integration kan ni automatisera medlemsinbetalningen. Ni behöver aldrig mer pricka av en faktura!</p>

                <h3>Automatisk avprickning</h3>
                <ul>
                    <li>Swish och kortbetalningar prickas av direkt.</li>
                    <li>BG-betalningar prickas av inom en bankdag.</li>
                </ul>

                <h3>Utbetalning varje vecka</h3>
                <p>Utbetalningar betalas ut den 25:e varje månad till erat konto automatiskt.</p>

                <h3>Priser</h3>
                <p>
                    Ni betalar en serviceavgift på 5-20 kr per betalning utifrån betalningens belopp.
                    Ett tips är att lägga på en avgift på 10-20 kr på era fakturor så blir tjänsten kostnadsfri för föreningen.
                </p>

                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Belopp</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Serviceavgift</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>1-200 kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>5 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>201-400 kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>8 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>401-700 kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>12 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>701-1500 kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>16 kr</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>1501- kr</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>20 kr</td>
                        </tr>
                    </tbody>
                </table>

                <p style={{ marginTop: '15px' }}>
                    <strong>Observera:</strong> Om ni väljer att tillåta kort som betalsätt tillkommer en extra avgift på 0,6 - 2,5%
                    beroende på vilket betal- eller kreditkort som används.
                </p>
            </div>
        </Modal>
    </LayoutLeftMenu>
};

export default AdminIntegrations;